import ForceGuide from '../../../common/forceGuide'

const workbenchForceGuide = new ForceGuide('workbenchForceGuide')

export const GUIDE_KEYS = {
  STEP_1: 1,
  STEP_2: 2
}

export const GUIDE_START_KEY = 'WORKBENCH_START_KEY'
export const WORKBENCH_FORCE_GUIDE_STEP_KEY = 'WORKBENCH_FORCE_GUIDE_STEP_KEY'
export default workbenchForceGuide
